import { IMAGE_UPLOAD_BUTTON_TYPE } from './imageUpload.constants';

export function UploadImageButton({
  buttonType = IMAGE_UPLOAD_BUTTON_TYPE.DEFAULT,
  buttonText,
  onClick,
}) {
  const btnClasses = {
    [IMAGE_UPLOAD_BUTTON_TYPE.DEFAULT]: 'btn cta-outlined-btn',
    [IMAGE_UPLOAD_BUTTON_TYPE.ICON]: 'btn text-btn',
  };

  return (
    <button
      type='button'
      className={btnClasses[buttonType] || btnClasses[IMAGE_UPLOAD_BUTTON_TYPE.DEFAULT]}
      onClick={onClick}
    >
      {buttonText}
    </button>
  );
}

export function ImagePreviewButton({ showPreview, multiple, previewLength, onClick }) {
  const resolvedButtonText = multiple ? `View (${previewLength})` : 'View';

  if (!showPreview || previewLength === 0) return null;

  return (
    <button type='button' className='btn text-btn' onClick={onClick}>
      {resolvedButtonText}
    </button>
  );
}
